<template>
  <section class="container new-authorization">
    <div class="row grid-margin" id="step1">
      <div class="col-xs-6">
        <div v-for="(templateDetails, index) in treatmentWiseTemplates" :key="index">
          <table class="table" v-if="index % 2 === 0">
            <thead class="head">
              <tr>
                <th>{{ templateDetails.TreatmentAreaDescription }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(template, index) in templateDetails.Templates" :key="index">
                <td @click="goToCreateAccountability(template.TemplateId)" >{{ template.Naam }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-xs-6">
        <div v-for="(templateDetails, index) in treatmentWiseTemplates" :key="index">
          <table class="table" v-if="index % 2 !== 0">
            <colgroup>
              <col v-for="n in 1" :key="n" :class="'table-col-' + n++">
            </colgroup>
            <thead class="head">
              <tr>
                <th>{{ templateDetails.TreatmentAreaDescription }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(template, index) in templateDetails.Templates" :key="index">
                <td @click="goToCreateAccountability(template.TemplateId)" >{{ template.Naam }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!--Pop up to show stop license -->
    <generic-modal v-if="showPopUp">
      <template #header>
        {{ popUpText.header }}
      </template>
      <template #body>
        <p>{{ popUpText.text }}</p>
      </template>
      <template #footer>
        <v-button tagelement="button" hollow md transparent @click.native="backToDashboard()" class="cancelPopUp">Annuleren</v-button>
        <v-button tagelement="button" md primary @click.native="closeLicense()">Doorgaan</v-button>
      </template>
    </generic-modal>
  </section>
</template>
<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import router from '@/router'
import 'intro.js/minified/introjs.min.css'
import introJs from 'intro.js'
import GenericModal from '@/components/shared/GenericModal'
import {
  navigateToAccountability
} from '@/services';

export default {
  name: 'v-newauthorization',
  components: {GenericModal},
  computed: {
    ...mapGetters({
      treatmentWiseTemplates: 'accountability/getTreatmentAreaWiseAccountabilityTemplates',
      showPopUp: 'accountability/getLicenseStopPopUpStatus',
      popUpText: 'login/getCloseLicensePopUpDetails'
    })
  },
  data () {
    return {
      intro: introJs()
    }
  },
  async created () {
    await store.dispatch('patient/getCurrentPatient')
    await store.dispatch('accountability/fetchAccountabilities')
    if (store.state.navigation.demo && store.state.navigation.demoActivated & store.state.navigation.demoFlow.createLicense) {
      setTimeout(() => {
        const self = this
        this.intro.setOptions({
          steps: [
            {element: '#step1', intro: 'Ieder portaal en elke patiënt behoeft een ander type machtiging, op deze pagina kunt u de specifieke machtigingstype voor de geselecteerde patiënt uitkiezen.', position: 'right'}
          ],
          exitOnEsc: false,
          exitOnOverlayClick: false,
          skipLabel: 'Overslaan',
          nextLabel: 'Volgende >',
          prevLabel: '< Terug',
          doneLabel: 'Okey, begrepen'
        })
        this.intro.start().onchange(function () {
          self.intro.exit()
        }).oncomplete(function () {
          self.intro.exit()
        })
        window.scrollTo(0, 0)
      }, 1500)
    }
  },
  methods: {
    /**
     * @function goToCreateAccountability - Redirecting prescirber to create accountability page
     * @param {string} - id
     */
    goToCreateAccountability (id) {
      this.intro.exit()
      store.commit('accountability/setShowExtendLicensesBlock', false)
      store.dispatch('accountability/startNewAccountability', id).then((response) => {
        navigateToAccountability(response.regular.accountabilityId);
      })
    },
    backToDashboard () {
      router.push('/patientdashboard')
      store.commit('accountability/setLicenseStopPopUpStatus', false)
    },
    closeLicense () {
      store.commit('accountability/setLicenseStopPopUpStatus', false)
    }
  },
  destroyed () {
    store.commit('accountability/resetTreatmentAreaWiseTemplates', [])
    store.commit('accountability/setAccountabilities', [])
  }
}
</script>
<style lang="scss" scoped>
  .new-authorization {
    table {
      background-color: $white;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
      width: 100%;
      margin-bottom: 24px;
      > thead > tr {
        > th {
 
          font-size: map-get(map-get($type-settings, 2), font-size);;
          color: $teal-darkest;
          text-align: left;
          padding: 16px;
        }
      }
      > tbody {
        > tr {
          > td, > th {
            padding: 8px 16px;
            cursor: pointer;
            line-height: $base-line-height;
            color: $gray-darkest;
          }
        }
      }
    }
  }
</style>
